import { customFetch } from '../api-helper/apiHerlpers';
import apiUrls from '../../constants/apiUrls';
import { format } from 'react-string-format';

import moment from 'moment';


// const ROOT_URL = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyAP-x4GzxTaU51CFXifRyJDRa9PQf1woVU';


export async function loginUser(dispatch, loginPayload) {
    const requestOptions = {
        method: 'POST',
        redirect: 'follow',
        body: loginPayload
    };

    
    try {
        let response = await fetch(apiUrls.loginPath, requestOptions);
        let data = await response.json();
        if (data && data.userData && data.userData.userId) {
            dispatch({ type: 'REQUEST_LOGIN' });
            data['userData']['isAdminUser'] = await customFetch(format(apiUrls.isAdminPath, data.userData.userId));
            localStorage.setItem('currentUser', JSON.stringify(data['userData']));
            return data['userData'];
        } else {
            dispatch({ type: 'LOGIN_ERROR', error: data.errorDetails });
            return data.errorDetails;
        }
    } catch (error) {
        dispatch({ type: 'LOGIN_ERROR', error: error });
        return error;
    }
}

export async function keycloakUser(dispatch,applicationId,siteId,loginPayload, key) {
  try {
    const url1 = `https://smartwcm-gateway-smartwcm-qa1.dark.swcm.link/user/rest/v3/user/userto/applicationid/${applicationId}/username/${loginPayload}/type/username/?swcmTicket=69f2ed48-6850-4e0f-a2e9-90b54c50fd28`;

    const userResponse = await fetch(url1, { headers: { Authorization: key } }).then((res) => res.json());
    if (userResponse && userResponse.userId) {
      return isAdmin(dispatch,applicationId,siteId, userResponse, key);
    } else {
      throw new Error("User not found");
    }
  } catch (error) {
    dispatch({ type: "LOGIN_ERROR", error: error.message });
    throw error;
  }
}

async function isAdmin(dispatch,applicationId,siteId, userDetails, key) {
  try {
    const [isAdminResponse, permissionResponse, projectPermissionResponse] = await Promise.all([
      customFetch(format(apiUrls.isAdminPath,applicationId, userDetails.userId), key),
      customFetch(format(apiUrls.permissionsPath,applicationId,siteId, userDetails.userId), key),
      customFetch(format(apiUrls.projectManagerProjects,applicationId,siteId,userDetails.userId ),key)
    ]);

    const permissions = permissionResponse.permissions || [];

   
    const updatedUserDetails = {
      ...userDetails,
      isAdminUser: isAdminResponse,
    };

    const pmProjects = await getProjectManagerProjects(
      userDetails.userId,
      key
    );

   
    const isGlobalAdmin =
      permissions.includes("Administrator") ||
      permissions.includes("SMA_MS");
    
const projectPermissions =
  normalizeProjectPermissions(projectPermissionResponse);

  const projectRoles =
  extractProjectRoles(projectPermissionResponse);

dispatch({
  type: "SET_PROJECT_ROLES",
  payload: projectRoles,
});

localStorage.setItem(
  "projectRoles",
  JSON.stringify(projectRoles)
);


dispatch({
  type: "SET_PROJECT_PERMISSIONS",
  payload: projectPermissions,
});


localStorage.setItem(
  "projectPermissions",
  JSON.stringify(projectPermissions)
);

   
    localStorage.setItem(
      "isGlobalAdmin",
      JSON.stringify(isGlobalAdmin)
    );

    
    dispatch({
      type: "LOGIN_SUCCESS",
      payload: {
        user: updatedUserDetails,
        permissions,

        
        isAdminUser: isGlobalAdmin,

       
        isAdminUI: isGlobalAdmin,

       
        pmProjects,

      
        isGlobalAdmin,
        projectPermissions,
      },
    });

   
    localStorage.setItem("currentUser", JSON.stringify(updatedUserDetails));
    localStorage.setItem("userPermissions", JSON.stringify(permissions));
    localStorage.setItem("pmProjects", JSON.stringify(pmProjects));
   

    return {
      user: updatedUserDetails,
      permissions,
      isAdminUI: isGlobalAdmin,
    };
  } catch (error) {
    console.error("Failed to fetch admin/permissions", error);
    throw error;
  }
}

async function getProjectManagerProjects(applicationId,siteId,userId, key) {
  const url = format(
    apiUrls.projectManagerProjects,
    applicationId,siteId,
    userId
  );

  const response = await customFetch(url, key);

  if (!response.json) return [];

  const parsed = JSON.parse(response.json);

  return parsed.contentIdList || []; 
}





export async function isAdminUser(dispatch, userDetails,key) {
        try {
            var response = await customFetch((format(apiUrls.isAdminPath, userDetails.userId)),key);
            userDetails['isAdminUser'] = response;
            dispatch({ type: 'LOGIN_SUCCESS', payload: userDetails });
            localStorage.setItem('currentUser', JSON.stringify(userDetails));
            
            return response;
        } catch (error) {
            return;
        }
    }    

export async function logout(dispatch) {
    dispatch({ type: 'LOGOUT' });
    dispatch({ type: 'REQUEST_TASK_LIST', payload: [] });
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
    localStorage.removeItem('isAdminUser');
    localStorage.removeItem('keycloakToken');
    return;
}

export async function getTaskList(dispatch, applicationId, siteId, searchData, token) {
   
    let startDate = 0;
    let endDate = 0;
    if (searchData.filterStartDate) {
        startDate = moment(searchData.filterStartDate).format('DD-MM-YYYY');
    }
    if (searchData.filterEndDate) {
        endDate = moment(searchData.filterEndDate).format('DD-MM-YYYY');
    }

    searchData.masterProjectId = searchData.masterProjectId ? searchData.masterProjectId : 0;
    searchData.masterReleaseId = searchData.masterReleaseId ? searchData.masterReleaseId : 0;
    searchData.masterUserId = searchData.masterUserId ? searchData.masterUserId : 0;
    searchData.masterFeatureId = searchData.masterFeatureId ? searchData.masterFeatureId : 0;

    let path = format(apiUrls.tasks, applicationId, siteId, searchData.masterProjectId, searchData.masterReleaseId, searchData.masterUserId, searchData.userStoryId, searchData.masterFeatureId, startDate, endDate);
    
    try {
        let response = await customFetch(path, token);
        dispatch({ type: 'REQUEST_TASK_LIST', payload: response });
        return response;
    } catch (error) {
        return;
    }
}

function normalizeProjectPermissions(apiResponse) {
  const map = {};

  if (!apiResponse || !apiResponse.json) return map;

  const parsed = JSON.parse(apiResponse.json);

  (parsed.contentRolePermissionHBList || []).forEach(item => {
    const projectId = item.contentId;

    map[projectId] = item.permissionList.map(p =>
      p.split("_").pop() // AR, AF, AU, etc
    );
  });

  return map;
}

export function extractProjectRoles(apiResponse) {
  const roleMap = {};

  if (!apiResponse || !apiResponse.json) return roleMap;

  const parsed = JSON.parse(apiResponse.json);

  (parsed.contentRolePermissionHBList || []).forEach(item => {
    const projectId = item.contentId;

    roleMap[projectId] = {
      roleName: item.roleTO?.roleName || "",
      roleLevel: item.roleTO?.roleLevel || null,
      roleId: item.roleTO?.roleId || null
    };
  });

  return roleMap;
}
